<div class="mobile-plan-footer mobile">
  <div class="container">
    <div class="row">
      <div class="col-12 plan">
        @if (brand !== 'Lambo') {
          <div class="text-center">
            <div class="plan-name">{{currentPlan?.name}}</div>
            <span class="plan-terms">{{convertTermLabel(plan?.planTerms ? plan.planTerms[plan.term.termIndex]?.planTermSKUName : "")}}</span>
            @if (currentPlan?.term?.deductible !== undefined && currentPlan?.term?.deductible !== null) {
              <span class="deductible">
                , ${{currentPlan?.term?.deductible}} {{ 'CART_CHECKOUT.DEDUCTIBLE_OCCURENCE' | translate }}
              </span>
            }
            @if (currentPlan?.term?.commercialUseSelected) {
              <span>, Commerical Coverage</span>
            }
          </div>
        }
        @if (brand === 'Lambo') {
          <div class="text-center">
            <div class="plan-name">{{currentPlan?.name}}</div>
            <span class="plan-terms">{{ plan?.planTerms?.[plan.term?.termIndex]?.planTermSKUName | lamboUnlimitedMileageTerm }}</span>
          </div>
        }
      </div>
    </div>
    <div class="col-12 text-center add-button">
      <button mdbBtn class="btn primary-btn waves-light add-to-cart-button-mobile" id="addToCartButtonMobile" mdbWavesEffect type="submit" (click)="addToCart()">
        <span>
          {{ 'RATES_PAGE.ADD_TO_CART' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
